import React, { useEffect } from 'react'

import { CollectionDetails as ICollectionDetails } from 'meta/pages/collection'
import { ApiEndpoint } from 'controller/endpoint'
import { AnalyticsContentType, AnalyticsEventType, trackFbPixelEvent } from 'utils/analytics/track'

import { Grid } from 'components/Layout/Grid'
import { useFacebookPixelId, useS2SToken } from 'hooks/useEnv'

import CoverBox from './Coverbox'
import Header from './Header'
import { useUserData } from 'hooks/useAuth'

const CollectionDetails: React.FC<ICollectionDetails> = (props) => {
  const { header, cover, fbPixel, googleTags, name, id } = props

  const s2sToken = useS2SToken()

  const ticketsmsFbPixelId = useFacebookPixelId()
  
  const userData = useUserData()

  const fbPixelCallback = () => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (window && window.fbq) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      fbPixel && window.fbq('init', fbPixel)
    }

    trackFbPixelEvent(
      AnalyticsEventType.ViewContent,
      {
        content_name: name,
        content_ids: [id],
        content_type: AnalyticsContentType.ticket,
        value: 1,
        currency: 'EUR',
      },
      {
        route: ApiEndpoint.analytics.event(id),
        fromOrganizer: fbPixel !== ticketsmsFbPixelId,
        s2sToken: s2sToken,
      },
      userData
    )
  }

  const ga4Callback = () => {
    //@ts-ignore
    if (window.gtag) {
      if (googleTags) {
        googleTags.map((elem) => {
          //@ts-ignore
          window.gtag('config', elem)
        })
      }

      //@ts-ignore
      window.gtag('event', 'view_item', {
        currency: 'EUR',
        value: 1,
        event_label: id,
        event_category: AnalyticsContentType.ticket,
        ticket_platform: "TicketSms",
        items: [
          {
            item_id: id,
            item_name: name,
          },
        ],
      })
    }
  }

  useEffect(() => {
    fbPixelCallback()
    ga4Callback()
  }, [])

  return (
    <Grid>
      <Header {...header} />
      <CoverBox {...cover} />
    </Grid>
  )
}

export default CollectionDetails
